import React from 'react';
import SnackBar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';

import useStyle from './Snackbar_style';

export const CustomeSnackBar = ({ open, setOpen }) => {

    const classes = useStyle();
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') { return; }
        setOpen(false);
    }
    return (
        <div className={classes.root}>
            <SnackBar anchorOrigin={{
                vertical: 'top', horizontal: 'right'
            }}
                open={open}
                autoHideDuration={4000}
                onClose={handleClose}>
                <MuiAlert onClose={handleClose} severity='success' elevation={6} variant='filled'>
                    Transaction sucessfull created.
                    </MuiAlert>
            </SnackBar>

        </div>
    )
}